import { GetterTree } from 'vuex';
import { GDHState } from './state';
import RootState from '@/store/root_state';

const getters: GetterTree<GDHState, RootState> = {
  isAlreadyClosedMgmModal: (state) => !!JSON.parse(state.serviceData).alreadyClosedMgmModal,
  alreadyClosedMgmModal: (state) => JSON.parse(state.serviceData).alreadyClosedMgmModal,
  alreadyClosedMgmHellobar: (state) => JSON.parse(state.serviceData).alreadyClosedMgmHellobar,
  alreadySubscribedToMgm: (state) => JSON.parse(state.serviceData).alreadySubscribedToMgm,
  closedMgmTooltip: (state) => JSON.parse(state.serviceData).closedMgmTooltip,
  alreadyOpenMgmModal: (state) => JSON.parse(state.serviceData).alreadyOpenMgmModal,
  alreadyDisplayed30daysNotification: (state) =>
    !!JSON.parse(state.serviceData).alreadyDisplayed30daysNotification,
  tooltipDisplayed: (state) => !!JSON.parse(state.serviceData).tooltipDisplayed,
};

export default getters;
